export async function submitReport(postId: string, reportReason: string, creatorId: string): Promise<Response> {
    const url = `${SiteInfo.starsApiUrl}/api/report/post`

    const response = await fetch(url, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${userData.accessToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            post_id: postId,
            report_reason: reportReason,
            creator_id: creatorId,
        }),
    })

    return await response
}
